import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { useGroupedNonCompliances } from './_load/GroupedNonCompliancesLoader'
import Chart from './Chart'

const List = ({ widget }) => {
  const { width } = widget?.size || {}
  const data = useGroupedNonCompliances()
  let colWidth = '20%'

  if (width <= 37) {
    colWidth = '100%'
  } else if (width <= 60) {
    colWidth = '50%'
  } else if (width <= 80) {
    colWidth = '33.33%'
  } else if (width <= 95) {
    colWidth = '25%'
  }

  return (
    <Grid wrap paddingGutter={0.4} justify="center">
      {data.map(item => (
        <Col key={item.id} width={colWidth}>
          <Chart widget={widget} item={item} />
        </Col>
      ))}
    </Grid>
  )
}

export default List
